import recoveryIllustration from "@/assets/froppio-password-reset.svg";
import { Button } from "@/shared/components/shadcn/Button";
import { Input } from "@/shared/components/shadcn/Input";
import { FormField } from "@/shared/components/ui/FormField";
import { FormPage } from "@/shared/components/ui/FormPage";
import { SectionAction } from "@/shared/components/ui/SectionAction";
import { Link, useLocation } from "react-router-dom";
import { EntryHeader } from "../components/EntryHeader";

export function PasswordRecoveryPage() {
  const location = useLocation();

  return (
    <FormPage
      header={null}
      narrow
      contentClassName="flex min-h-full flex-col justify-center space-y-0 py-6"
      onSubmit={(event) => event.preventDefault()}
      actions={
        <Button type="submit" disabled aria-describedby="recovery-unavailable">
          Send reset link
        </Button>
      }
    >
      <EntryHeader
        title="Forgot your password?"
        illustration={recoveryIllustration}
        illustrationAlt="Froppio holding a password reset envelope"
      />
      <div className="space-y-6">
        <p id="recovery-unavailable" className="text-sm leading-relaxed text-muted-foreground">
          Password recovery is not available in Froppio yet. You cannot send a reset link from this page.
          No email will be collected or sent.
        </p>
        <FormField id="recovery-email" label="Email">
          <Input type="email" autoComplete="off" disabled aria-describedby="recovery-unavailable" />
        </FormField>
      </div>
      <p className="mt-2 text-center">
        <SectionAction asChild>
          <Link to="/login" state={location.state}>Sign in</Link>
        </SectionAction>
      </p>
    </FormPage>
  );
}
